import React from 'react';
import HeroLogo from './HeroLogo';
import HeroSupportButton from './HeroSupportButton';
import styles from './onboardingHero.module.css';

interface HeroHeaderProps {
  supportLabel?: string;
  supportHref?: string;
}

const HeroHeader: React.FC<HeroHeaderProps> = ({ supportLabel, supportHref }) => (
  <header className={styles.header}>
    <HeroLogo />
    {supportLabel && supportHref ? (
      <HeroSupportButton label={supportLabel} href={supportHref} />
    ) : null}
  </header>
);

export default HeroHeader;
